import React from "react";
import { CSVPreview } from "../../components/calibrationModal/CSVPreview";
import { formatSensorType } from "shared/utils";
import type { UseBulkUploadReturn } from "../../components/calibrationModal/hooks/useBulkUpload";

interface BulkPreviewStepProps {
  individualCalibrationData: any;
  bulkUpload: UseBulkUploadReturn;
}

const SummaryItem: React.FC<{ label: string; value?: string }> = ({ label, value }) => (
  <div>
    <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
    <p className="mt-0.5 text-sm font-medium text-gray-900">{value || "—"}</p>
  </div>
);

export const BulkPreviewStep: React.FC<BulkPreviewStepProps> = ({
  individualCalibrationData,
  bulkUpload,
}) => {
  return (
    <div className="space-y-6">
      <div className="rounded-xl border border-blue-200 bg-blue-50/40 p-4">
        <h3 className="mb-4 text-lg font-medium text-gray-900">Sensor Filters</h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <SummaryItem
            label="Sensor Type"
            value={formatSensorType(individualCalibrationData.sensorType)}
          />
          <SummaryItem label="Category" value={individualCalibrationData.category} />
          {individualCalibrationData.modelFamily && (
            <SummaryItem label="Displacement Sensor Type" value={individualCalibrationData.modelFamily} />
          )}
          <SummaryItem label="Model" value={individualCalibrationData.model} />
          <SummaryItem label="Range" value={individualCalibrationData.range} />
        </div>
      </div>

      <div className="rounded-xl border border-blue-200 bg-blue-50/40 p-4">
        <h3 className="mb-4 text-lg font-medium text-gray-900">Upload Details</h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <SummaryItem label="Selected File" value={bulkUpload.selectedFiles[0]?.name} />
          <SummaryItem
            label="Equipment Calibration Certificate Number"
            value={bulkUpload.equipmentCalibrationCertificateNo}
          />
        </div>
      </div>

      <div className="rounded-xl border border-blue-200 bg-white p-4">
        <h4 className="mb-3 text-sm font-semibold text-gray-800">CSV preview</h4>
        <CSVPreview
          csvPreviewData={bulkUpload.csvPreviewData}
          columnOrder={bulkUpload.csvColumnOrder}
          showPreview={bulkUpload.showPreview}
          onTogglePreview={() => bulkUpload.setShowPreview((prev) => !prev)}
        />
      </div>
    </div>
  );
};
